import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule } from "@angular/forms";

import { FocusDirective } from "./directives/my-date-range-picker.focus.directive";
import { MyDateRangePicker } from "./my-date-range-picker.component";

@NgModule({
	imports: [CommonModule, FormsModule.withConfig({ callSetDisabledState: "whenDisabledForLegacyCode" })],
	declarations: [MyDateRangePicker, FocusDirective],
	exports: [MyDateRangePicker, FocusDirective],
})
export class MyDateRangePickerModule {}
